import { render, staticRenderFns } from "./ParcelasAcordo.vue?vue&type=template&id=1c915ef4"
import script from "./ParcelasAcordo.vue?vue&type=script&lang=js"
export * from "./ParcelasAcordo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports